import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageDropdown.css";

const LanguageDropdown = () => {
  const { i18n } = useTranslation();  // i18n 가져오기
  const [selectedLang, setSelectedLang] = useState("KR");

  const langMap = {
    KR: "ko",
    EN: "en",
    JP: "ja",
    CN: "zh"
  };

  const languageChange = (e) => {
    const selected = e.target.value;
    const i18nLang = langMap[selected] || "ko";
    setSelectedLang(selected);
    i18n.changeLanguage(i18nLang);
    localStorage.setItem("lang", selected);				// 드롭다운용
    localStorage.setItem("i18nextLng", i18nLang);   // i18n 기준
    sessionStorage.setItem("langSession", "true");	// 세션 유지 표시
  };

  useEffect(() => {
    const hasSession = sessionStorage.getItem("langSession");

    // 세션이 없으면 → 한국어 초기화
    if (!hasSession) {
      i18n.changeLanguage("ko");
      setSelectedLang("KR");
      localStorage.setItem("lang", "KR");
      localStorage.setItem("i18nextLng", "ko");
      sessionStorage.setItem("langSession", "true");
    } else {
      // 세션이 있으면 → 저장된 언어 적용
      const savedLang = localStorage.getItem("lang") || "KR";
      const i18nLang = langMap[savedLang] || "ko";
      setSelectedLang(savedLang);
      i18n.changeLanguage(i18nLang);
    }
  }, []);

  return (
    <select value={selectedLang} onChange={languageChange} className="language-dropdown">
      <option value="KR">language(한국어)</option>
      <option value="EN">English</option>
      <option value="JP">日本語</option>
      <option value="CN">中文</option>
    </select>
  );
};

export default LanguageDropdown;
